import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { IS_PASSWORD_SYSTEM_GENERATED } from "../redux/constants/Auth";

function SetHelpPageRoutes() {
    const credentialsGeneratedByUser = localStorage.getItem(IS_PASSWORD_SYSTEM_GENERATED) === "false" ? true : false;

  return credentialsGeneratedByUser ? <Outlet /> : <Navigate to="/" />;
}

export default SetHelpPageRoutes;
